import { Component,OnInit, AfterViewChecked, ViewEncapsulation } from '@angular/core';
import { MainNavigationBase, MainNavigationService } from './Shared/service/MainNavigation.service';
import { ConfigurationReaderBase } from './Shared/service/ConfigurationReader';
import { ClientSideUtility } from './Shared/service/ClientSideUtility';
import { IDPConfiguration, AuthenticationBase } from './Shared/service/Authentication';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { ScriptLoaderServiceBase } from './Shared/service/script-loader.service';
import { Helpers } from './Shared/service/helpers';


@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class AppComponent implements OnInit {
    title = 'app';
    globalBodyClass = 'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

    constructor(private route: ActivatedRoute,
        private router: Router,
        private configurationReader: ConfigurationReaderBase,
        private authenticationService: AuthenticationBase,
        private _script: ScriptLoaderServiceBase ) {
        
        let config = this.configurationReader.Configuration;

        let idpConfig: IDPConfiguration = {
        baseURL: window.location.origin,
        idpClient: config.idpClient,
        idpRedirect: config.idpRedirect,
        idpScope: config.idpScope,
        idpURL: config.idpURL,
        idpPostLogoutURL: config.idpPostLogoutURL,
        idpSilentRefreshURL: config.idpSilentRefreshURL,
        idpDoSilentRefresh: config.idpDoSilentRefresh
        };

        this.authenticationService.configure(idpConfig);        
    }

    ngOnInit() {

        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/theme/default/base/scripts.bundle.js'], true)
            .then(() => {
            Helpers.setLoading(false);
          });

        this.router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                Helpers.setLoading(true);
                Helpers.bodyClass(this.globalBodyClass);
            }
            if (route instanceof NavigationEnd) {
                Helpers.setLoading(false);
            }
        });
    }

    isUserAuthenticated():boolean{

        return this.authenticationService.isAuthenticated();
    }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/app.component.ts